module.exports = __webpack_public_path__ + "static/img/programmable-splitter_256.41d4d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/programmable-splitter_256.png
// module id = 0NXV
// module chunks = 0